import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import ApiDocsLayer from "../components/ApiDocsLayer";

const ApiDocsPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout pageTitle="API Docs">

        {/* ApiDocsLayer */}
        <ApiDocsLayer />
      </MasterLayout>
    </>
  );
};

export default ApiDocsPage;
